"use strict";

angular.module("customer")
.service("InviteToRegisterService", function($http, appConfig) {

    this.get = function(customerId) {
        return $http.get(
            appConfig.API_SERVER + "/sales-representatives/customers/" + customerId + "/invite-to-register/"
        );
    };

    this.invite = function(customerId, email) {
        return $http.post(
            appConfig.API_SERVER + "/sales-representatives/customers/" + customerId + "/invite-to-register/",
            {email: email}
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/invite-to-register/invite-to-register.service.js
// module id = 861
// module chunks = 0